import { createReducer } from '@reduxjs/toolkit';

import { fetchUsers } from './actions';

export default createReducer([], {
  [`${fetchUsers}-success`]: (state, { payload: users }) => users,
});
